import PropTypes from 'prop-types';

import { lcResourcePreviewType } from 'humanity/components/lcResourcePreview';

export const lcRelatedArticlesProps = {
  title: PropTypes.string.isRequired,
  articles: PropTypes.arrayOf(lcResourcePreviewType).isRequired,
};

export const lcRelatedArticlesType = PropTypes.shape({
  title: PropTypes.string.isRequired,
  articlesCollection: PropTypes.shape({ items: PropTypes.arrayOf(lcResourcePreviewType) })
    .isRequired,
});
